export default "__VITE_ASSET__Ck6Imfpi__"